import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EnquirySidebarService } from './service/enquiry-sidebar.service';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-enquiry-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SidebarModule,
    InputTextModule,
    ButtonModule,
    DropdownModule
  ],
  templateUrl: './enquiry-sidebar.component.html',
  styleUrl: './enquiry-sidebar.component.scss'
})
export class EnquirySidebarComponent {
  visible = false;
  planOptions = [
    { label: 'Professional', value: 'Professional' },
    { label: 'Business', value: 'Business' },
    { label: 'Enterprise', value: 'Enterprise' }
  ];
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private sidebarService: EnquirySidebarService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      organization: ['', Validators.required],
      plan: [null, Validators.required],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      query: ['', Validators.required]
    });

    this.sidebarService.toggle$.subscribe(val => {
      this.visible = val;
    });
  }


  openSidebar() {
    this.visible = true;
  }

  onSidebarHide() {
    this.visible = false;
  }

  submit() {
    if (this.form.valid) {
      this.visible = false;
      this.sidebarService.postContactUs(this.form.value).subscribe({
        next: (res) => {
          this.toastr.success("Thank you for contacting us. We will get back to you shortly.", "Success!");
          this.form.reset();
          this.form.markAsPristine();
          this.form.markAsUntouched();
        },
        error: (err) => {
          console.error('Error:', err);
        }
      });
    } else {
      this.form.markAllAsTouched();
    }
  }
}
